// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.checkbox[data-v-2e2a26e3] .v-input--selection-controls__input {\r\n  margin: 0.3rem !important;\n}\n.checkbox[data-v-2e2a26e3] .v-input--selection-controls__ripple {\r\n  height: 0 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
